// /** @format */
// import React from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import './global-date-filter.styles.scss';

// const CustomInput = ({
//   title,
//   openCalendar,
//   value,
//   handleValueChange,
//   readOnly,
//   type,
// }) => (
//   <input
//     title={title}
//     onFocus={openCalendar}
//     value={value}
//     onChange={handleValueChange}
//     readOnly={readOnly}
//     className={type ? 'form-input-date' : 'short-input'}
//   />
// );

// const GlobalDateFilter = ({
//   label,
//   value,
//   readonly,
//   maxDate,
//   minDate,
//   format,
//   placeholder,
//   handleChange,
//   type,
//   filter,
// }) => {
//   return (
//     <div
//       className={filter ? 'date-filter-container' : 'date-filter-container-new'}
//     >
//       <label className={type ? 'to-date-filter-title' : 'date-filter-title'}>
//         {label}
//       </label>
//       <DatePicker
//         render={(props) => (
//           <CustomInput
//             title={label}
//             openCalendar={props.openCalendar}
//             value={props.value}
//             handleValueChange={props.handleValueChange}
//             readOnly={readonly}
//             type={type}
//           />
//         )}
//         format={format}
//         minDate={minDate}
//         maxDate={maxDate}
//         onChange={handleChange}
//         readOnly={readonly}
//         value={value}
//         hideOnScroll
//         placeholder={placeholder}
//       />
//     </div>
//   );
// };

// export default GlobalDateFilter;

/** @format */
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './global-date-filter.styles.scss';

const CustomInput = React.forwardRef(
  ({ title, value, onClick, readOnly, type }, ref) => (
    <input
      ref={ref}
      title={title}
      onClick={onClick}
      value={value}
      readOnly={readOnly}
      className={type ? 'form-input-date' : 'short-input'}
    />
  )
);

const GlobalDateFilter = ({
  label,
  value,
  readonly,
  maxDate,
  minDate,
  format,
  placeholder,
  handleChange,
  type,
  filter,
}) => {
  return (
    <div
      className={filter ? 'date-filter-container' : 'date-filter-container-new'}
    >
      <label className={type ? 'to-date-filter-title' : 'date-filter-title'}>
        {label}
      </label>
      <DatePicker
        selected={value}
        onChange={handleChange}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={format}
        readOnly={readonly}
        placeholderText={placeholder}
        customInput={
          <CustomInput title={label} readOnly={readonly} type={type} />
        }
      />
    </div>
  );
};

export default GlobalDateFilter;
